module.exports = __webpack_public_path__ + "roboto-v18-vietnamese_latin-ext_latin_greek_cyrillic-ext_greek-ext_cyrillic-regular.6866c2b6420618fdf5d3.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Roboto/roboto-v18-vietnamese_latin-ext_latin_greek_cyrillic-ext_greek-ext_cyrillic-regular.eot
// module id = ../../../../../src/assets/fonts/Roboto/roboto-v18-vietnamese_latin-ext_latin_greek_cyrillic-ext_greek-ext_cyrillic-regular.eot
// module chunks = styles